/**
 * @voltxampere/ui — LM358 dual general-purpose op-amp variant (Sprint 39-1)
 *
 * Datasheet-named op-amp preset. Generic op-amp visual (op-amp.ts SVG
 * reuse) + LM358 datasheet parameter profile. Single-supply 3 V – 32 V,
 * 1 MHz GBW, 0.3 V/μs slew, 100 V/mV open-loop gain.
 *
 * Reference: TI SLOS068P. The engine consumes only `openLoopGain`,
 * `saturationVoltage`, and `gainBandwidthProduct`; the rest of the
 * datasheet (slew rate, supply rails, input bias) is metadata
 * surfaced through Inspector / sidebar UI.
 *
 * Engine zero-diff invariant honored — this variant maps to the
 * canonical `opamp` engine stamp via `schemaType`. No new engine
 * type registered; the existing Sprint 7 op-amp stamp consumes
 * the datasheet params.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampLm358 = {
    id: "lm358",
    nameTr: "LM358 (Genel-Amaçlı, DIP-8)",
    nameEn: "LM358 (General-Purpose, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "LM358",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 1e5,
        saturationVoltage: 12,
        gainBandwidthProduct: 1e6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-lm358.js.map